import { connect } from 'react-redux';
import { hot } from 'react-hot-loader/root';
import { getURL } from '~/server/formatters';
import {
  getMatch,
  campaignsPage,
  profileTabPages,
  calendarPage,
  contentPage,
  blueprintsPage,
} from '~/routes';
import { actions as analyticsActions } from '~/analytics-middleware/actions';

import ProfileSidebar from './components/ProfileSidebar';
import { actions } from './reducer';

export default hot(
  connect(
    (state, ownProps) => {
      const accountChannelsURL = getURL.getAccountChannelsURL();

      const { profiles } = state.profileSidebar;

      const reachedChannelLimit =
        state.organizations.selected?.profileLimit <=
        state.organizations.selected?.profilesCount;

      return {
        loading: state.profileSidebar.loading,
        selectedProfile: state.profileSidebar.selectedProfile,
        selectedProfileId: ownProps.profileId,
        profiles,
        searchText: state.profileSidebar.searchText,
        translations: state.i18n.translations['profile-sidebar'],
        profileLimit: state.organizations.selected?.profileLimit,
        hasCampaignsFlip: state.organizations.selected?.hasCampaignsFeature,
        canManageSocialAccounts:
          state.organizations.selected?.canManageSocialAccounts,
        ownerEmail: state.organizations.selected?.ownerEmail,
        isCampaignsSelected: !!getMatch({
          pathname: state.router?.location?.pathname,
          route: campaignsPage.route,
        }),
        isBlueprintsSelected: !!getMatch({
          pathname: state.router?.location?.pathname,
          route: blueprintsPage.route,
        }),
        reachedChannelLimit,
        manageChannelsURL:
          accountChannelsURL || getURL.getManageSocialAccountURL(),
        isCalendarSelected: !!getMatch({
          pathname: state.router?.location?.pathname,
          route: calendarPage.route,
        }),
        isContentSelected: !!getMatch({
          pathname: state.router?.location?.pathname,
          route: contentPage.route,
        }),
      };
    },
    (dispatch) => ({
      onProfileClick: (profile) => {
        dispatch(
          profileTabPages.goTo({
            profileId: profile.id,
            tabId: 'queue',
          })
        );
        dispatch(
          actions.selectProfile({
            profile,
          })
        );
      },
      onDropProfile: ({
        commit,
        organizationId,
        profileLimit,
        dragIndex,
        hoverIndex,
      }) => {
        // Sometimes commit can be false. We don't want to track this.
        if (commit) {
          const metadata = {
            product: 'publish',
            organizationId,
            clientName: 'publishWeb',
          };
          dispatch(analyticsActions.trackEvent('Channels Reordered', metadata));
        }
        dispatch(
          actions.onDropProfile({
            commit,
            profileLimit,
            dragIndex,
            hoverIndex,
          })
        );
      },
      onSearchProfileChange: (value) => {
        dispatch(actions.handleSearchProfileChange({ value }));
      },
      onContentButtonClick: () => {
        dispatch(contentPage.goTo());
      },
      onCampaignsButtonClick: () => {
        dispatch(campaignsPage.goTo());
      },
      onBlueprintsButtonClick: () => {
        dispatch(blueprintsPage.goTo());
      },
      onCalendarButtonClick: () => {
        const metadata = {
          source: 'sidebar',
          calendarVersion: 'new',
        };
        dispatch(analyticsActions.trackEvent('Calendar Opened', metadata));
        dispatch(calendarPage.goTo());
      },
    })
  )(ProfileSidebar)
);

export { default as reducer, actions, actionTypes } from './reducer';
export { default as middleware } from './middleware';
